import { MRT_Localization, type MRT_RowData, type MRT_TableOptions } from 'material-react-table';
import { useTranslation } from 'react-i18next';
import { getStripedRowsForExpansion } from 'services/util';

import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization_DE } from 'material-react-table/locales/de';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import { MRT_Localization_IT } from 'material-react-table/locales/it';
import { MRT_Localization_PL } from 'material-react-table/locales/pl';
import { MRT_Localization_RU } from 'material-react-table/locales/ru';

const getLocalizationMapping = () : Partial<MRT_Localization> => {
  const { i18n } = useTranslation();
  switch (i18n.language) {
    case 'es_ES':
      return MRT_Localization_ES;
    case 'de_DE':
      return MRT_Localization_DE;
    case 'fr_FR':
      return MRT_Localization_FR;
    case 'it_IT':
      return MRT_Localization_IT;
    case 'pl_PL':
      return MRT_Localization_PL;
    case 'ru_RU':
      return MRT_Localization_RU;
    default:
      return MRT_Localization_EN;
  }
};

export const getDefaultMRTOptions = <TData extends MRT_RowData>(): Partial<
  MRT_TableOptions<TData>
> => {
    const { t } = useTranslation();
    return {
      layoutMode: "semantic",
      initialState: { 
        showColumnFilters: false,
        density: 'compact',
        columnVisibility: {
          'mrt-row-expand': false,
        },
      },
      muiTableHeadCellProps: () => ({
        sx: {
          padding: '4px',
        },
      }),
      muiTableBodyCellProps: () => ({
        sx: {
          padding: '4px',
        },
      }),
      displayColumnDefOptions: {
        'mrt-row-actions': {
          header: t('Edit'),
          size: 10, 
        },
        'mrt-row-select': {
          size: 10, 
        },
        'mrt-row-numbers': {
          size: 10, 
        },
      },
      manualFiltering: true,
      manualPagination: true,
      manualSorting: true,
      enableSorting: false,
      enableMultiSort: false,
      maxLeafRowFilterDepth: 0, // only filter root rows
      editDisplayMode: 'cell',
      enableEditing: false,
      enableSubRowSelection: false,
      enableColumnPinning: false,
      enableRowPinning: false,
      enableExpanding: false,
      enableColumnActions: false,
      enableColumnFilters: true,
      enableColumnFilterModes: true,
      enableFacetedValues: false,
      enableExpandAll: true,
      autoResetExpanded: true,
      enableRowSelection: false,
      enableSelectAll: false,
      positionToolbarAlertBanner: 'bottom',
      muiTableBodyRowProps: ({ row }) => ({
        height: '37px',
        hover: true,
        sx: { 
          cursor: 'pointer',
          '& td': {
            backgroundColor: getStripedRowsForExpansion(row),
          },
        },
      }),
      renderTopToolbarCustomActions: () => (
        <p />
      ),
      positionGlobalFilter: 'none',
      renderToolbarInternalActions: () => (
        <p />
      ),
      defaultColumn: {
        columnFilterModeOptions: [
          'fuzzy',
        ],
        enableColumnFilter: false,
        enableColumnFilterModes: false,
      },
      state: {
        showProgressBars: false,
        showGlobalFilter: false,
      },
      localization: getLocalizationMapping()
    };
}